import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Container, Section, Grid, Button } from '../components/ui';
import SEO from '../components/SEO';

const PageHeader = styled.div`
  text-align: center; padding: 4rem 0; background: #f9fafb;
`;

const PageTitle = styled.h1`margin-bottom: 1rem;`;

const PageDesc = styled.p`
  color: #6b7280; font-size: 1.125rem; max-width: 600px; margin: 0 auto;
`;

const ProductCard = styled(Link)`
  display: block; background: white; border-radius: 1rem;
  overflow: hidden; box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  transition: all 250ms ease; text-decoration: none;
  &:hover { transform: translateY(-4px); box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1); }
`;

const ProductImg = styled.div`
  height: 320px; background-image: url(${({ $src }) => $src});
  background-size: cover; background-position: center; position: relative;
`;

const Badge = styled.span`
  position: absolute; top: 1rem; left: 1rem;
  background: #eab308; color: #0f0f0f;
  font-size: 0.75rem; font-weight: 600; padding: 0.25rem 0.5rem;
  border-radius: 0.25rem; text-transform: uppercase;
`;

const ProductContent = styled.div`padding: 1.5rem;`;

const ProductPrice = styled.div`
  font-size: 1.5rem; font-weight: 700; color: #0f0f0f; margin-bottom: 0.5rem;
`;

const ProductName = styled.h3`color: #0f0f0f; margin-bottom: 0.75rem;`;

const ProductDesc = styled.p`
  color: #6b7280; font-size: 0.875rem; line-height: 1.625; margin-bottom: 1rem;
`;

const products = [
  // Row 1: Calendars
  {
    slug: 'newcalendar_classic',
    productId: '8393084436792',
    name: 'The New Calendar Classic',
    price: 25,
    image: 'https://res.cloudinary.com/dqy3fktlv/image/upload/v1700665978/EKJClknXYAgIzI2_pk6dy9.jpg',
    description: 'The original perpetual wall calendar with comprehensive user guide. Designed to last from 2019 to 9999.',
    badge: 'Best Seller',
  },
  {
    slug: 'newcalendar_wallmap',
    productId: '10239741395256',
    name: 'Wall Map (3\' × 4\')',
    price: 150,
    image: 'https://res.cloudinary.com/dqy3fktlv/image/upload/v1734522897/IMG_7101copycopy_z9ck6d.jpg',
    description: 'Large format dry-erase planning calendar. Perfect for offices, classrooms, and serious planners.',
    badge: 'Premium',
  },
  // Row 2: Tees
  {
    slug: 'white-logo-black-tee',
    productId: '10714278986040',
    name: 'White Logo on Black Tee',
    price: 16,
    image: 'https://cdn.shopify.com/s/files/1/0788/8394/6808/files/unisex-classic-tee-dark-heather-front-6a1c23092be3e.jpg?v=1780228882',
    description: 'Classic unisex tee with The New Calendar logo. Comfortable cotton blend.',
  },
  {
    slug: 'black-logo-white-tee',
    productId: '10714278396216',
    name: 'Black Logo on White Tee',
    price: 16,
    image: 'https://cdn.shopify.com/s/files/1/0788/8394/6808/files/unisex-classic-tee-ash-front-6a1c212b8374c.jpg?v=1780228407',
    description: 'Classic unisex tee with The New Calendar logo. Comfortable cotton blend.',
  },
  // Row 3: Crop top & Polo
  {
    slug: 'crop-top',
    productId: '10714276528440',
    name: 'New Calendar Crop Top',
    price: 30,
    image: 'https://cdn.shopify.com/s/files/1/0788/8394/6808/files/womens-crop-top-ecru-front-6a1c1aca314e6.jpg?v=1780226779',
    description: 'Stylish crop top featuring The New Calendar logo.',
  },
  {
    slug: 'polo-shirt',
    productId: '10714273579320',
    name: 'New Calendar Polo Shirt',
    price: 40,
    image: 'https://cdn.shopify.com/s/files/1/0788/8394/6808/files/unisex-pique-polo-shirt-navy-front-6a1c1109df000.jpg?v=1780224282',
    description: 'Professional piqué polo with embroidered logo. Perfect for the office.',
  },
  // Row 4: Sun Shirts (New Calendar & Betsy Ross)
  {
    slug: 'new-calendar-sun-shirt',
    productId: '10714273415480',
    name: 'New Calendar Sun Shirt',
    price: 72,
    image: 'https://cdn.shopify.com/s/files/1/0788/8394/6808/files/all-over-print-mens-sports-warmup-hoodie-front-6a1c102535c64.jpg?v=1780224068',
    description: 'Lightweight all-over print sun shirt. UPF protection meets revolutionary design.',
    badge: 'New',
  },
  {
    slug: 'betsy-ross-sun-shirt',
    productId: '10714272727352',
    name: 'The Betsy Ross Sun Shirt',
    price: 72,
    image: 'https://cdn.shopify.com/s/files/1/0788/8394/6808/files/all-over-print-mens-sports-warmup-hoodie-front-6a1c0c4d9dc18.jpg?v=1780223095',
    description: 'Patriotic all-over print sun shirt. UPF protection with classic American style.',
    badge: 'New',
  },
  // Row 5: Sun Shirts (Peace Time & Elite Officer)
  {
    slug: 'peace-time-sun-shirt',
    productId: '10714273186104',
    name: 'Peace Time Sun Shirt',
    price: 72,
    image: 'https://cdn.shopify.com/s/files/1/0788/8394/6808/files/all-over-print-mens-sports-warmup-hoodie-front-6a1c0e4a5e711.jpg?v=1780223612',
    description: 'Peaceful vibes all-over print sun shirt. UPF protection for outdoor adventures.',
    badge: 'New',
  },
  {
    slug: 'elite-officer-sun-shirt',
    productId: '10714277773624',
    name: 'Elite Officer Sun Shirt',
    price: 72,
    image: 'https://cdn.shopify.com/s/files/1/0788/8394/6808/files/all-over-print-mens-sports-warmup-hoodie-front-6a1c1f354e3a6.jpg?v=1780227932',
    description: 'Premium all-over print sun shirt with tropical Seychelle design.',
    badge: 'New',
  },
  // Row 6: Hoodies
  {
    slug: 'white-logo-black-hoodie',
    productId: '10714276856120',
    name: 'White Logo on Black Hoodie',
    price: 40,
    image: 'https://cdn.shopify.com/s/files/1/0788/8394/6808/files/unisex-heavy-blend-hoodie-black-front-6a1c1ba399d73.jpg?v=1780226994',
    description: 'Cozy heavy blend hoodie with The New Calendar logo. Perfect for cool seasons.',
  },
  {
    slug: 'black-logo-gray-hoodie',
    productId: '10714277183800',
    name: 'Black Logo on Gray Hoodie',
    price: 40,
    image: 'https://cdn.shopify.com/s/files/1/0788/8394/6808/files/unisex-heavy-blend-hoodie-ash-front-6a1c1c1fcccbd.jpg?v=1780227125',
    description: 'Cozy heavy blend hoodie with The New Calendar logo. Perfect for cool seasons.',
  },
];

const Shop = () => (
  <>
    <SEO title="Shop" description="Shop The New Calendar collection. Premium perpetual calendars designed and manufactured in the USA." url="https://thenewcalendar.com/shop" />
    
    <PageHeader>
      <Container>
        <PageTitle>Shop</PageTitle>
        <PageDesc>Calendars and apparel from The New Calendar. Take control of your time.</PageDesc>
      </Container>
    </PageHeader>

    <Section>
      <Container>
        <Grid cols={2} gap="2rem">
          {products.map(p => (
            <ProductCard key={p.slug} to={`/${p.slug}`}>
              <ProductImg $src={p.image}>
                {p.badge && <Badge>{p.badge}</Badge>}
              </ProductImg>
              <ProductContent>
                <ProductPrice>${p.price}</ProductPrice>
                <ProductName>{p.name}</ProductName>
                <ProductDesc>{p.description}</ProductDesc>
                <Button as="span" $fullWidth>View Product</Button>
              </ProductContent>
            </ProductCard>
          ))}
        </Grid>
      </Container>
    </Section>

    <Section $muted>
      <Container style={{ textAlign: 'center' }}>
        <h2 style={{ marginBottom: '1rem' }}>Need Something Custom?</h2>
        <p style={{ color: '#6b7280', marginBottom: '1.5rem', maxWidth: '480px', margin: '0 auto 1.5rem' }}>
          We offer custom calendars for businesses, events, and special occasions.
        </p>
        <Button as="a" href="mailto:tom@thenewcalendar.com?subject=Custom Calendar Inquiry" variant="outline">
          Contact Us
        </Button>
      </Container>
    </Section>
  </>
);

export default Shop;
